'use client';

import styled from 'styled-components';

export const BannerContainer = styled.div`
  grid-area: banner;
`;
